const CookiePolicy = () => {
  return (
    <div data-testid="cookie-policy-page" className="pt-32 pb-20 bg-white">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">Cookie Policy</h1>
          <p className="text-[#6E6E6E] mb-8">Last updated: December 2024</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">1. What Are Cookies</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Cookies are small text files that are placed on your computer or mobile device 
                when you visit our website. They are widely used to make websites work more 
                efficiently and provide information to website owners.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">2. How We Use Cookies</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">We use cookies to:</p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>Remember your preferences and settings</li>
                <li>Understand how you use our website</li>
                <li>Improve your browsing experience</li>
                <li>Analyze website traffic and performance</li>
                <li>Support our marketing efforts</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">3. Types of Cookies We Use</h2>
              
              <h3 className="font-heading text-lg text-[#2D2D2D] mb-2 mt-6">Essential Cookies</h3>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                These cookies are necessary for the website to function properly. They enable 
                basic functions like page navigation and access to secure areas of the website.
              </p>

              <h3 className="font-heading text-lg text-[#2D2D2D] mb-2 mt-6">Analytics Cookies</h3>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                These cookies help us understand how visitors interact with our website by 
                collecting and reporting information anonymously.
              </p>

              <h3 className="font-heading text-lg text-[#2D2D2D] mb-2 mt-6">Marketing Cookies</h3>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                These cookies are used to track visitors across websites to display relevant 
                advertisements.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">4. Third-Party Cookies</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Some cookies on our website are placed by third parties, including analytics 
                services (like Google Analytics) and advertising networks. These third parties 
                may collect information about your browsing activities across different websites.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">5. Managing Cookies</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Most web browsers allow you to control cookies through their settings. You can:
              </p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>Delete all cookies from your browser</li>
                <li>Block cookies from being set</li>
                <li>Allow cookies from specific websites only</li>
                <li>Set your browser to notify you when a cookie is being set</li>
              </ul>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Please note that blocking or deleting cookies may impact your experience on 
                our website and limit certain functionalities.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">6. Cookie Duration</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                <strong>Session cookies:</strong> These are temporary cookies that are deleted 
                when you close your browser.<br />
                <strong>Persistent cookies:</strong> These remain on your device for a set period 
                or until you delete them manually.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">7. Updates to This Policy</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                We may update this Cookie Policy from time to time. Any changes will be posted 
                on this page with an updated revision date.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">8. Contact Us</h2>
              <p className="text-[#6E6E6E] leading-relaxed">
                If you have questions about our use of cookies, please contact us at:<br />
                Email: support@decorsgenius.store<br />
                Phone: +1-888-880-1455
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
